var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"fill":"#E10E49","cx":"22.5","cy":"22.5","r":"22.5","key":0}),React.createElement("path",{"fill":"#FFF","d":"M31 22.5L18 30V15z","key":1})]));
}

Play.defaultProps = {"viewBox":"0 0 45 45"};

module.exports = Play;

Play.default = Play;
